const unallowedKey = '__typename';

export function cleanGQLData(data: unknown): unknown {
    if (typeof data !== 'object') {
        return data;
    }

    let result: any;

    if (Array.isArray(data)) {
        result = [];

        for (let i = 0; i < data.length; i++) {
            const currentData = data[i];

            result.push(cleanGQLData(currentData));
        }
    } else {
        if (data === null) {
            return data;
        }

        result = {};
        const keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            if (key !== unallowedKey) {
                result[key] = cleanGQLData((data as { [key: string]: unknown })[key]);
            }
        }
    }

    return result;
}
